export function largestFilesUrl(buildingId: string, search: string): string {
  const params = new URLSearchParams(search);
  params.delete("folderId");
  params.delete("view");
  params.set("storage", "largest");
  return `/buildings/${buildingId}/documents?${params}`;
}
